import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import { BASE_URL } from '../Config/Base';

const CorpOurteamMain = () => {

  useEffect(()=>{
    getCorpOT()
  },[])
  function getCorpOT(){
    const token = JSON.parse(localStorage.getItem('usertoken'));
  
   
  
    fetch(`${BASE_URL}/Kdpcorp/GetCorpOT`, {
      method:'GET',
  
    headers : {
  
      "Content-type": "application/json",
  
      "Accept": "application/json",
  
      "Authorization": "Bearer " +`${token}`,
  
      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },
  
  
  })
  
  .then(response => response.json())
  
  
  .then(data => {
  console.log("Section",data)
  
  localStorage.setItem("CorpOurteamContentData", JSON.stringify(data));
  });
  
 
  }
  return (
    <>
    
    <div className='Corp-addmainPicLife' >
    <div className='Corp-addmain' id="Corppicture">

    <div className="holder">


    <div className="dot dot7 con ">
      
      </div>
  
     
  <ul id='Corp-sectionMain' className="titles" >

  
   

   

<label for="Corp-touchC" id="corpsectionlable">

 
  &nbsp;<li id ="Corp-sectionC-head" className="title5 title-animate"><Link to="/CorpOurteamContent" id="Corplifetext" >Employee Details</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchC" /> 

<ul class="Corp-slide" id="Corp-slideC">

<ul className='CorpList'>
</ul>
</ul>
</ul>




    {/* </div>  */}

    </div>


  
    </div>


    
     </div>

    </>
  )
}

export default CorpOurteamMain